<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { Search, Wand2 } from 'lucide-svelte';

  import { submitFilters } from '$lib/api/filters';
  import { guidedActive, resetGuided } from '$lib/stores/guided';
  import { sidebarOpen } from '$lib/stores/ui';

  /**
   * Classic mode with nothing searched yet, for somebody who has left the
   * guided screen.
   *
   * # What was here
   *
   * A hero, two cards that looked interactive and were not, the sentence
   * `instructions.useFilters` printed three times, and a primary button that
   * ran an unfiltered search of the whole database. It was the first thing a
   * customer saw in classic mode.
   *
   * The guided screen is that first thing now. What is left is the quiet state
   * behind it: you skipped the guide, the filter panel is open beside you, and
   * this says so in one line and offers the guide back.
   */
</script>

<div class="max-w-md text-center">
  <div
    class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-surface bg-surface-sunken"
  >
    <Search class="h-6 w-6 text-gray-400" />
  </div>

  <h2 class="mb-1.5 text-base font-semibold text-gray-900">{$_('headings.readyToSearch')}</h2>
  <p class="mb-6 text-sm text-gray-600">{$_('instructions.useFilters')}</p>

  <div class="flex items-center justify-center gap-2">
    <button
      type="button"
      onclick={() => {
        resetGuided();
        guidedActive.set(true);
      }}
      class="inline-flex items-center gap-1.5 rounded-control border border-hairline bg-surface-panel px-3.5 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-hairline-strong hover:text-gray-900"
    >
      <Wand2 class="h-4 w-4" />
      {$_('guided.guideMe')}
    </button>

    <button
      type="button"
      onclick={() => {
        sidebarOpen.set(false);
        submitFilters();
      }}
      class="inline-flex items-center gap-1.5 rounded-control bg-accent-600 px-3.5 py-2 text-sm font-semibold text-white transition-colors hover:bg-accent-700"
    >
      <Search class="h-4 w-4" />
      {$_('buttons.search')}
    </button>
  </div>
</div>
